import React, { Component } from 'react'
import '../../Laboratory/Config/Config.css';
import { Button, Stack, TextField, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TablePagination, IconButton, Tooltip, Box, InputAdornment, FormControl, RadioGroup, FormControlLabel, Radio, Typography, Modal, Autocomplete, ListItem, ListItemButton, ListItemText, Divider, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { Colors } from '../../../Styles/Colors';
import RestAPIService from '../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../Utility/API/Serviceurls';
import ToastMsg from '../../../Components/ToastMsg/ToastMsg';
import { ImagePaths } from '../../../Utility/ImagePaths';
import { withTranslation } from 'react-i18next';
import { ConfirmPopup, DeletePopup } from '../../../Components/Common Components/CommonComponents';
import SearchIcon from '@mui/icons-material/Search';
import CancelTwoToneIcon from '@mui/icons-material/CancelTwoTone';
import { localGetItem } from '../../../Utility/Services/CacheProviderService';
import { CheckAccessFunc } from '../../../Components/CommonFunctions/CommonFunctions';
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css'
import CircularProgress from '@mui/material/CircularProgress';
import { DateTime } from 'luxon';
import CommonValidation from '../../../Components/CommonFunctions/CommonValidation';

class RadESign extends Component {
    constructor(props) {
        super(props)
        this.state = {
            page: 0,
            rowsPerPage: 10,
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: '',
            selectedIndex: '',
            SearchText: "",
            SelectedRole: "",
            SelectedName: "",
            SelectedStatus: true,
            imgUpload: [],
            SelectedImage: null,
            isImgClicked: false,
            selectedEditID: '',
            EsignatureList: [],
            deletedapiID: "",
            rad_ID: null,
            org_id: null,
            S3bucketsize: 0,
            src: null,
            crop: {
                unit: "%",
                x: 22.5,
                y: 30,
                width: 60,
                height: 25,
                aspect: 16 / 9,
            },
            CropPop: false,
            FileName: "",
            selectedData: "",
            rotation: 0,
            imageURL: "",
            removeData: false,
            files: [],
            isLoader: false,
            disableBtn: false,
            roleTypeList: [],
            AddnewRoleType: false,
            editRoleName: false,
            addRoleName: '',
            isAdd: false,
            renameRole: false,
            roleSelectID: null,
            deleteRole: false,
        }
        this.uploadImage = React.createRef();
    }

    componentDidMount() {
        this.getSignatureData()
        this.getRoleMaster()
        var myUser = JSON.parse(localGetItem("loggedInUserInfo"))
        this.setState({
            rad_ID: myUser?.radiology_id,
            org_id: myUser?.org_id,
        })
    }
    LoaderFunction = (key) => {
        this.setState({
            isLoader: key
        })
    }
    getRoleMaster = () => {
        try {
            this.LoaderFunction(true)
            RestAPIService.getAll(Serviceurls.RAD_ROLE_MASTER_GET)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        this.setState({
                            roleTypeList: response?.data?.data,
                        });
                        this.LoaderFunction(false)
                    }
                })
                .catch((e) => {
                    this.LoaderFunction(false)
                    this.errorMessage(e?.response?.data?.message || e.message)
                })
        } catch (e) {
            this.LoaderFunction(false)
            this.errorMessage(e.message)
        }
    }


    getSignatureData = () => {
        try {
            this.LoaderFunction(true)
            RestAPIService.getAll(Serviceurls.RAD_ESIGN_GET).
                then((response) => {
                    if (response.data.status === "success") {
                        this.setState({ EsignatureList: response.data.data, isLoader: false, }
                        )
                    }
                }).catch((e) => {
                    this.LoaderFunction(false)
                    this.errorMessage(e?.response?.data?.message || e?.message)
                })
        } catch (e) {
            this.LoaderFunction(false)
            this.errorMessage(e.message)
        }
    }
    successMessage = (message) => {
        this.setState({
            successMsg: true,
            successMsgText: message
        })
    }
    errorMessage = (message) => {
        this.setState({
            isErrorMsg: true,
            isErrorMsgText: message
        })
    }

    postSignatureData = (filePath) => {
        var states = this.state
        let data = {
            "name": states.SelectedName ? states.SelectedName : "",
            "role": states.SelectedRole ? states.SelectedRole : "",
            "status": states.SelectedStatus ? JSON.parse(states.SelectedStatus) : false,
            "e_sign": filePath,
        }

        if (this.state.selectedEditID) {
            data['id'] = states.selectedEditID ? states.selectedEditID : null
        }
        this.LoaderFunction(true)
        try {
            RestAPIService.create(data, Serviceurls.RAD_ESIGN_GET)
                .then(response => {
                    if (response.data.status == "success") {
                        this.successMessage(response.data.message)
                        this.getSignatureData()
                        this.clearValue()
                    }
                }).catch(e => {
                    this.LoaderFunction(false)
                    this.errorMessage(e?.response?.data?.message || e.message)
                })
        } catch (e) {
            this.LoaderFunction(false)
            this.errorMessage(e.message)
        }
    }

    msgClose() {
        this.setState({
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: '',
        })
    }

    async getS3Key(doc_key) {
        try {
            const response = await RestAPIService.getAllTwo(Serviceurls.AWS_URL_GET + "?doc_key=" + encodeURIComponent(doc_key));

            if (response.data.status === "success") {
                const Data = response.data;
                return (Data.data)
            }
        } catch (e) {
            this.errorMessage("Error fetching S3 URL")
        }
    }

    editCultureTestData = async (item, index) => {
        let Upload = []
        let val = await this.getS3Key(item?.e_sign)
        Upload.push(val)
        this.setState({
            imgUpload: []
        }, () => {
            this.setState({
                selectedIndex: index,
                SelectedRole: item?.role_id,
                SelectedName: item?.name,
                SelectedStatus: item?.status,
                selectedEditID: item?.id,
                imgUpload: Upload,
                SelectedImage: Upload[0],
                imageURL: item?.e_sign
            })
        })
    }

    deleteCultureData = (ID) => {
        try {
            RestAPIService.deleteAll(Serviceurls.RAD_ESIGN_GET + "?id=" + ID)
                .then(response => {
                    if (response.data.status == "success") {
                        this.setState({
                            successMsg: true,
                            successMsgText: response.data.message
                        }, () => {
                            this.setState({
                                selectedKey: null,
                                deletePopup: false
                            }
                            )
                            this.getSignatureData()
                        })
                    }
                }).catch((e => {
                    this.errorMessage(e?.response?.data?.message || e?.message)
                }))

        } catch (e) {
            this.errorMessage(e.message)
        }
    }

    handleChangePage = (event, newPage) => {
        this.setState({ page: newPage });
    }

    handleChangeRowsPerPage = (event) => {
        this.setState({ rowsPerPage: +event.target.value, page: 0 });
    }

    clearValue = () => {
        this.setState({
            SearchText: "",
            SelectedRole: "",
            SelectedName: "",
            SelectedStatus: true,
            imgUpload: [],
            SelectedImage: null,
            isImgClicked: false,
            selectedEditID: '',
            selectedIndex: '',
            FileName: "",
            selectedData: "",
            AddnewRoleType: false,
            editRoleName: false,
            addRoleName: '',
            isAdd: false,
            renameRole: false,
            roleSelectID: null,
            deleteRole: false,
        })
    }

    PopupClose = () => {
        this.setState({
            deletedPopup: false
        })
    }

    removeDataList = () => {
        this.deleteCultureData(this.state.deletedapiID)
        this.setState({
            deletedPopup: false
        })
    }

    renderLeftTable = () => {
        var states = this.state
        const { t } = this.props
        const filtereddata = this.state.EsignatureList?.filter((data) => {
            return (
                (data?.role_name === null ? null : data?.role_name.toLowerCase().includes(this.state.SearchText?.toLowerCase())) ||
                (data?.name === null ? null : data?.name.toLowerCase().includes(this.state.SearchText?.toLowerCase()))
            );
        });
        return (
            <div>
                <Paper elevation={0}>
                    <Box className="eMed_Search_Box_">
                        <TextField
                            variant='standard'
                            placeholder='Search'
                            value={this.state.SearchText}
                            onChange={(e) => { this.setState({ SearchText: e.target.value }) }}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon />
                                    </InputAdornment>
                                ),
                            }}
                            sx={{ width: '15vw' }} />
                    </Box>
                    <TableContainer className='eMed_ConfigTable_Paper'>
                        <Table stickyHeader size='small'>
                            <TableHead sx={{ height: '7.3vh' }}>
                                <TableRow>
                                    <TableCell id='eMed_config_TableRow1' align='left' sx={{ color: Colors.HeadText }} >{t('SNo')}</TableCell>
                                    <TableCell id='eMed_config_TableRow' align='left' sx={{ color: Colors.HeadText }}>{t("Role")}</TableCell>
                                    <TableCell id='eMed_config_TableRow' align='left' sx={{ color: Colors.HeadText }}>{t("Name")}</TableCell>
                                    <TableCell id='eMed_config_TableRow' align='left' sx={{ color: Colors.HeadText }}>{t("Status")}</TableCell>
                                    <TableCell id='eMed_config_TableRow' align='center' sx={{ color: Colors.HeadText }}>{t('Action')}</TableCell>
                                </TableRow>
                            </TableHead>
                            {states.isLoader ?
                                <Box sx={{ display: 'flex', justifyContent: 'center', position: 'relative', left: '22vw', top: '14vw' }}>
                                    <CircularProgress color='primary' />
                                </Box>
                                : filtereddata.slice(states.page * states.rowsPerPage, states.page * states.rowsPerPage + states.rowsPerPage)
                                    .map((data, index) => {
                                        var sno = (states.page * states.rowsPerPage) + (index + 1)
                                        return (
                                            <TableBody>
                                                <TableRow sx={{ bgcolor: this.state.selectedEditID && this.state.selectedIndex == index ? '#e2e2e2' : 'white' }}>
                                                    <TableCell align='left'><div>{sno}</div></TableCell>
                                                    <TableCell align='left'><div>{data?.role_name}</div></TableCell>
                                                    <TableCell align='left'><div>{data?.name}</div></TableCell>
                                                    <TableCell align='left'><div>{data.status == true ? "Active" : "Inactive"}</div></TableCell>
                                                    <TableCell align='center'>
                                                        <div className='eMed_TestConfig_Con'>
                                                            <IconButton size='small' disabled={!CheckAccessFunc("Radiology", "Settings", "E-Signature Configuration", null, "Tab")?.editAccess}>
                                                                <img src={CheckAccessFunc("Radiology", "Settings", "E-Signature Configuration", null, "Tab")?.editAccess ? ImagePaths.Edit.default : ImagePaths.DisabledEdit.default}
                                                                    className='eMed_TestConfig_DeleteIcon' alt='Edit'
                                                                    onClick={() => { this.editCultureTestData(data, index) }}
                                                                />
                                                            </IconButton>
                                                            <IconButton size='small' disabled={!CheckAccessFunc("Radiology", "Settings", "E-Signature Configuration", null, "Tab")?.editAccess}>
                                                                <img src={CheckAccessFunc("Radiology", "Settings", "E-Signature Configuration", null, "Tab")?.editAccess ? ImagePaths.Delete.default : ImagePaths.DisabledDelete.default}
                                                                    className='eMed_TestConfig_DeleteIcon' alt='Delete'
                                                                    onClick={() => {
                                                                        this.setState({ deletedPopup: true, deletedapiID: data.id, selectedData: data })
                                                                    }}
                                                                />
                                                            </IconButton>
                                                        </div>
                                                    </TableCell>
                                                </TableRow>
                                            </TableBody>
                                        )
                                    })
                            }
                        </Table>
                        {filtereddata?.length === 0 ?
                            <div className='eMed_TestConfig_NoRecords'>
                                {t('NoRecordsShown')}
                            </div>
                            : null}
                    </TableContainer>
                </Paper>
                <div className='eMed_TestConfig_LeftPageination'>
                    <TablePagination
                        component='div'
                        id="eMed_tbl_pagination"
                        rowsPerPageOptions={[10, 20, 30]}
                        count={filtereddata?.length ? filtereddata.length : 0}
                        rowsPerPage={states.rowsPerPage}
                        page={states.page}
                        onPageChange={this.handleChangePage}
                        onRowsPerPageChange={this.handleChangeRowsPerPage}
                    />
                </div>
            </div>
        )
    }

    onImageRemove = (index) => {
        let { imgUpload } = this.state;
        imgUpload.splice(index, 1)
        this.setState({
            imgUpload: this.state.imgUpload,
        })
    }

    UploadcroppedImg = () => {
        let blob = this.state.croppedImageUrl;
        let NewFile = []
        fetch(blob)
            .then(response => response.blob())
            .then(blob => {
                const file = new File([blob], this.state.FileName, { type: blob.type });
                NewFile.push(file)
                this.setState({
                    imgUpload: NewFile,
                    crop: {
                        unit: "%",
                        x: 22.5,
                        y: 30,
                        width: 60,
                        height: 25,
                        aspect: 16 / 9,
                    }
                })
            })
            .catch(error => console.error('Error fetching blob:', error));
    }

    handleChange = async (e) => {
        if (e.target.files && e.target.files.length > 0) {
            const reader = new FileReader();
            reader.addEventListener("load", () =>
                this.setState({ src: reader.result, CropPop: true })
            );
            this.setState({ FileName: e.target.files[0]?.name })
            reader.readAsDataURL(e.target.files[0]);
        }
        this.uploadImage.current.value = null;
    }

    s3FileUpload = async (item = []) => {
        try {
            if (item?.length > 0) {
                for (let i = 0; i < item?.length; i++) {
                    let filePath = ''
                    let currentDate = new Date()
                    if (item[i].name) {
                        filePath = "rad/" + this.state.org_id + "/" + this.state.rad_ID;
                    } else {
                        if (this.state.selectedEditID) {
                            filePath = this.state.imageURL
                        }
                    }

                    const data = new FormData();
                    data.append('file_data', item[i]);
                    data.append('folder_path', filePath);
                    data.append('current_date', DateTime.fromJSDate(currentDate).toFormat('yyyy-MM-dd HH:mm:ss'));
                    this.setState({ loading: true, disableBtn: true })

                    RestAPIService.create(data, Serviceurls.LAB_ESIGN_UPLOAD)
                        .then((response) => {
                            if (response.data.status === 'success') {
                                this.successMessage('File uploaded successfully')
                                var Data = response.data?.data
                                this.postSignatureData(Data)
                                this.setState({ loading: false, imageuploadList: [], disableBtn: false })
                            }
                        }).catch((error) => {
                            this.setState({ loading: false, disableBtn: false })
                            this.errorMessage(error?.message || 'File Upload Failed')
                        })
                    // }
                }
            } else {
                this.errorMessage('Please add at least one file')
                this.setState({ disableBtn: false })
            }
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    renderImgCard = () => {
        const { t } = this.props;
        let imageListLen = this.state.imgUpload.length;
        let { imageURL } = this.state
        return (
            <Stack className="eMed_DocRepo_imgDiv" justifyContent="center" alignItems="center" sx={{ backgroundColor: Colors.SecondaryFill }}>
                <input
                    type="file"
                    accept="image/jpg, image/jpeg, image/png"
                    onChange={this.handleChange}
                    ref={this.uploadImage}
                    style={{ display: "none" }}
                />
                <Stack direction="column" justifyContent="center" alignItems="center" spacing={1}>
                    <Stack className="eMed_DocRepo_imgSubDiv" justifyContent="center" alignItems="center" spacing={0.5}>
                        <IconButton size="small" disabled={imageListLen === 6 ? true : false} onClick={() => this.uploadImage.current.click()}><img id="eMed_upload_img" src={imageListLen === 6 ? ImagePaths.LabUploadButton.default : ImagePaths.Export.default} alt="Upload" /></IconButton>
                        <Typography id="eMed_img_lblTxt" >{imageListLen === 6 ? t("MaxUpload") : t("uploadFile")}</Typography>
                        {imageListLen === 6 ? null : <Typography id="eMed_img_subTxt" sx={{ marginLeft: "0.5vw" }}>{t("imgFormat")}</Typography>}
                    </Stack>
                    {
                        imageListLen > 0 ?
                            <Stack className="eMed_Testrep_Img_item" direction="row" justifyContent={imageListLen <= 5 ? "center" : "flex-start"} alignItems="center">
                                {imageListLen > 0 && this.state.imgUpload.map((image, index) => (
                                    <div key={index} className="eMed_Testrep_Img" style={{ marginRight: "0.5vw" }}>
                                        <Tooltip title={typeof (image) === "string" ? null : image?.name} arrow placement='top'>
                                            <img
                                                onClick={() => {
                                                    if (typeof (image) === "string") {
                                                        if (imageURL.split('.').pop() === "jpg" || imageURL.split('.').pop() === "jpeg" || imageURL.split('.').pop() === "JPG" || imageURL.split('.').pop() === "png") {
                                                            this.setState({ isImgClicked: true, popUpOpen: true, SelectedImage: image })
                                                        }
                                                        else {
                                                            window.open(image)
                                                        }
                                                    } else {
                                                        this.setState({ isImgClicked: true, popUpOpen: true, SelectedImage: URL.createObjectURL(image) })
                                                    }
                                                }}
                                                src={ImagePaths.ImagePreview.default} className='eMed_Testrep_Img' />
                                        </Tooltip>
                                        <div><IconButton id="eMed_Testrep_Icon" size="small"
                                            onClick={() => {
                                                this.setState({ SelectedImage: null }, () => { this.onImageRemove(index) });
                                            }}>
                                            <CancelTwoToneIcon fontSize='small' color="error" />
                                        </IconButton></div>
                                    </div>
                                ))}
                            </Stack>
                            : null
                    }
                </Stack>
            </Stack>
        )
    }

    rotateImage = (degrees) => {
        this.setState({
            rotation: (this.state.rotation + degrees) % 360
        })
    };

    handleClose = () => {
        this.setState({
            imgUpload: [],
            SelectedImage: null,
            isImgClicked: false,
            selectedEditID: '',
            selectedIndex: '',
            FileName: "",
            selectedData: "",
            CropPop: false,
            crop: {
                unit: "%",
                x: 22.5,
                y: 30,
                width: 60,
                height: 25,
                aspect: 16 / 9,
            }
        })
    }

    previewPopup = () => {
        return (
            <Box>
                <Modal open={true}>
                    <Paper elevation={3} id="emedhub_vendorDetails_mainBox" style={{ width: "40vw", height: "70vh" }}>
                        <div id="emedhub_vendorDetails_header">
                            <Typography>{"Image Preview"}</Typography>
                            <IconButton onClick={() => { this.setState({ popUpOpen: false }) }} size="small" ><img className="eMed_DeletePopup_CrossIcon" src={ImagePaths.LabCloseButton.default} alt={"close"} /></IconButton>
                        </div>
                        <Box component={'div'} style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", height: "90%" }}>
                            <img src={this.state.SelectedImage} alt='Image Preview' style={{ width: "45%", height: "45%" }} />
                        </Box>
                    </Paper>
                </Modal>
            </Box>
        )
    }

    OpenCropPopUP = () => {
        const { crop, croppedImageUrl, src } = this.state;
        try {
            return (
                <Box>
                    <Modal open={true}>
                        <Paper elevation={3} id="emedhub_vendorDetails_mainBox" style={{ width: "60vw", height: "80vh" }}>
                            <div id="emedhub_vendorDetails_header">
                                <Typography>{"Crop Signature"}</Typography>
                                <IconButton onClick={this.handleClose} size="small" ><img className="eMed_DeletePopup_CrossIcon" src={ImagePaths.LabCloseButton.default} alt={"close"} /></IconButton>
                            </div>
                            <Box component={'div'} style={{ marginTop: "0.75vw", height: "25vw" }}>
                                <div style={{ display: "flex", flexDirection: "row", width: "100%" }}>
                                    <div style={{ width: "60%", height: "100%", marginTop: "1.5vw", marginLeft: "1.5vw" }}>
                                        {src && (
                                            <ReactCrop
                                                style={{ height: "50%", width: "62%" }}
                                                src={src}
                                                crop={crop}
                                                ruleOfThirds
                                                onImageLoaded={this.onImageLoaded}
                                                onComplete={this.onCropComplete}
                                                onChange={this.onCropChange}
                                            />
                                        )}
                                    </div>
                                    <div style={{ width: "50%", display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", marginLeft: "-1.5vw", marginRight: "2.5vw" }}>
                                        {croppedImageUrl && (
                                            <img alt="Crop" style={{ width: "75%", height: "45%", transform: `rotate(${this.state.rotation}deg)` }} src={croppedImageUrl} />
                                        )}
                                    </div>
                                </div>
                            </Box>
                            <Box component={'div'} style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}>
                                <Button variant='contained' size='small' id="eMed_Config_btn" onClick={() => { this.setState({ CropPop: false }, () => { this.UploadcroppedImg() }) }}>OK</Button>
                            </Box>
                        </Paper>
                    </Modal>
                </Box>
            );
        } catch (error) {
            this.errorMessage(error.message)
        }
    };

    onImageLoaded = image => {
        this.imageRef = image;
    };

    onCropComplete = crop => {
        this.makeClientCrop(crop);
    };

    onCropChange = (crop, percentCrop) => {
        this.setState({ crop });
    };

    async makeClientCrop(crop) {
        if (this.imageRef && crop.width && crop.height) {
            const croppedImageUrl = await this.getCroppedImg(
                this.imageRef,
                crop,
                this.state.FileName,
                this.state.rotation
            );
            this.setState({ croppedImageUrl });
        }
    }

    getCroppedImg(image, crop, fileName) {
        const canvas = document.createElement("canvas");
        const scaleX = image.naturalWidth / image.width;
        const scaleY = image.naturalHeight / image.height;
        canvas.width = crop.width;
        canvas.height = crop.height;
        const ctx = canvas.getContext("2d");

        ctx.drawImage(
            image,
            crop.x * scaleX,
            crop.y * scaleY,
            crop.width * scaleX,
            crop.height * scaleY,
            0,
            0,
            crop.width,
            crop.height
        );

        return new Promise((resolve, reject) => {
            canvas.toBlob(blob => {
                if (!blob) {
                    console.error("Canvas is empty");
                    return;
                }
                blob.name = fileName;
                window.URL.revokeObjectURL(this.fileUrl);
                this.fileUrl = window.URL.createObjectURL(blob);
                resolve(this.fileUrl);
            }, "image/jpeg");
        });
    }

    validation = () => {
        let { SelectedName, SelectedRole, imgUpload } = this.state
        if (!imgUpload || imgUpload.length === 0) {
            return this.errorMessage("Please add at least one file");
        }
        if (SelectedName !== "" && SelectedRole !== "") {
            if (!imgUpload[0]?.name && this.state.selectedEditID) {
                this.postSignatureData(this.state.imageURL)
            } else {
                this.s3FileUpload(imgUpload)
            }
        } else {
            if (SelectedName == "") {
                this.errorMessage("Please enter the name")
            } else if (SelectedRole == "") {
                this.errorMessage("Please select the role")
            }
        }
    }

    renderRoleAdd = () => {
        const { t } = this.props
        return (
            <Dialog open={this.state.AddnewRoleType} >
                <DialogTitle className='eMed_CreditPoP_TitleDiv' sx={{ borderColor: Colors.themeDark }}>
                    <Typography marginLeft={"1vw"}>{this.state?.editRoleName ? "Edit Role Name" : "Add Role Name"}</Typography>
                    <Button onClick={() => { this.setState({ AddnewRoleType: false }) }} >
                        <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' />
                    </Button>
                </DialogTitle>
                <DialogContent sx={{ padding: "2vw" }}>
                    <TextField
                        inputProps={{ maxLength: 30 }}
                        sx={{ width: "20vw", marginTop: "2vw" }}
                        size='small'
                        label={'Role Name'}
                        value={this.state?.addRoleName}
                        onChange={(event) => {
                            let alphanum = CommonValidation.alphanumValidation(event.target.value);
                            if (alphanum || event.target.value === '') {
                                this.setState({
                                    addRoleName: event.target.value
                                })
                            }
                        }}
                    />
                    {this.state?.editRoleName ? <Typography sx={{ fontSize: '.9vw', color: "#888888" }}>{'Editing this will also affect previous reports.'}</Typography> : null}
                </DialogContent>
                <DialogActions>
                    <Button variant='outlined' size='small' className='eMed_Filter_Btns' onClick={() => { this.setState({ addRoleName: '' }) }}>{t("Clear")}</Button>
                    <Button variant='contained' size='small' disabled={this.state?.isAdd} className='eMed_Filter_Btns' onClick={() => {
                        if (this.state?.addRoleName != '') {
                            this.sendRoleMaster()
                        } else {
                            this.errorMessage('Please Enter the Role Name')
                        }
                    }}>{this.state?.renameRole ? t("Rename") : t("Add")}</Button>
                </DialogActions>
            </Dialog>
        )
    }

    sendRoleMaster = () => {
        try {
            this.setState({ isAdd: true })
            let data = {
                'name': this.state?.addRoleName,
            }
            if (this.state?.renameRole && this.state?.roleSelectID) {
                data['id'] = this.state?.roleSelectID
            }
            RestAPIService.create(data, Serviceurls.RAD_ROLE_MASTER_GET)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        this.successMessage(response.data.message)
                        this.setState({
                            AddnewRoleType: false,
                            addRoleName: '',
                            editRoleName: false,
                            renameRole: false,
                            isAdd: false,
                        }, () => {
                            this.getRoleMaster()
                        })
                    }
                })
                .catch((e) => {
                    this.setState({ isAdd: false })
                    this.errorMessage(e?.response?.data?.message || e.message)
                })
        } catch (e) {
            this.setState({ isAdd: false })
            this.errorMessage(e.message)
        }
    }

    deleteRole = () => {
        try {
            this.LoaderFunction(true)
            RestAPIService.delete(`${Serviceurls.RAD_ROLE_MASTER_GET}?id=${this.state?.roleSelectID}`)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        this.setState({
                            deleteRole: false,
                            roleSelectID: null,
                            SelectedRole: '',
                            addRoleName: '',
                            editRoleName: false,
                        }, () => {
                            this.getRoleMaster()
                        })
                    }
                })
                .catch((e) => {
                    this.LoaderFunction(false)
                    this.errorMessage(e?.response?.data?.message || e.message)
                })
        } catch (e) {
            this.LoaderFunction(false)
            this.errorMessage(e.message)
        }
    }
    popClose = () => {
        this.setState({
            deleteRole: false,
        })
    }

    render() {
        const { t } = this.props
        return (
            <div className='eMed_TestConfig_MainContainer'>
                <div className='eMed_TestConfig_Con'>
                    <div className='eMed_TestConfig_leftSide'>
                        {this.renderLeftTable()}
                    </div>
                    <div className='eMed_TestConfig_RightSide'>
                        <div className='eMed_TestConfig_RightHead' style={{ height: "5.5vh" }}>
                            <p className='eMed_Testconfig_RightHead_text'>{t('E-Signature')}</p>
                        </div>
                        <div className='eMed_CulturalConfig_RightContentBox'>
                            <div style={{ display: "flex", flexDirection: "row", padding: "1vw", justifyContent: "space-between", alignItems: "center" }}>
                                <Autocomplete
                                    size="small"
                                    sx={{ width: "14vw" }}
                                    value={
                                        this.state?.roleTypeList?.find((r) => r.id === this.state?.SelectedRole) || null
                                    }
                                    onChange={(event, newValue) => {
                                        if (newValue) {
                                            this.setState({
                                                SelectedRole: newValue.id,
                                                editRoleName: true,
                                                roleSelectID: newValue.id,
                                                addRoleName: newValue.name,
                                            });
                                        } else {
                                            this.setState({
                                                SelectedRole: "",
                                                editRoleName: false,
                                                roleSelectID: null,
                                                addRoleName: '',
                                            });
                                        }
                                    }}
                                    options={this.state?.roleTypeList}
                                    getOptionLabel={(option) => option.name || ""}
                                    renderInput={(params) => (
                                        <TextField {...params} label={t("Select Role")} />
                                    )}
                                    renderOption={(props, option) => (
                                        <li {...props}
                                            style={{
                                                whiteSpace: 'normal',
                                                wordBreak: 'break-word',
                                                lineHeight: '1.3',
                                            }}>
                                            {option.name}
                                        </li>
                                    )}
                                    // Custom dropdown to include Add / Rename / Delete
                                    PaperComponent={({ children }) => (
                                        <Box
                                            backgroundColor={'white'}
                                            onMouseDown={(e) => e.preventDefault()}   // IMPORTANT FIX
                                        >
                                            {children}
                                            <Divider />

                                            {/* Add Role */}
                                            <ListItem disablePadding>
                                                <ListItemButton
                                                    onClick={(e) => {
                                                        e.stopPropagation(); // prevent Autocomplete close
                                                        this.setState({
                                                            AddnewRoleType: true,
                                                            addRoleName: "",
                                                            renameRole: false,
                                                            roleSelectID: null,
                                                        });
                                                    }}
                                                >
                                                    <ListItemText primary={"Add Role Name"} />
                                                </ListItemButton>
                                            </ListItem>

                                            {/* Rename & Delete only if role selected */}
                                            {this.state?.editRoleName && (
                                                <>
                                                    <ListItem disablePadding>
                                                        <ListItemButton
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                this.setState({
                                                                    AddnewRoleType: true,
                                                                    renameRole: true,
                                                                });
                                                            }}
                                                        >
                                                            <ListItemText primary={"Rename"} />
                                                        </ListItemButton>
                                                    </ListItem>

                                                    <ListItem disablePadding>
                                                        <ListItemButton
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                this.setState({
                                                                    deleteRole: true,
                                                                });
                                                            }}
                                                        >
                                                            <ListItemText primary={"Delete"} />
                                                        </ListItemButton>
                                                    </ListItem>
                                                </>
                                            )}
                                        </Box>
                                    )}
                                />
                                <TextField
                                    size='small'
                                    variant='outlined'
                                    label={'Name'}
                                    value={this.state.SelectedName}
                                    style={{ width: "14vw" }}
                                    inputProps={{ maxLength: 40 }}
                                    onChange={(event) => {
                                        this.setState({
                                            SelectedName: event.target.value
                                        })
                                    }}
                                />
                            </div>
                        </div>
                        <div style={{ marginTop: "-0.65vw" }}>
                            <p className='eMed_Testconfig_RightHead_text'>{t('Status')}</p>
                        </div>
                        <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", paddingLeft: "0.6vw", marginTop: "-0.5vw" }}>
                            <FormControl disabled={this.state.selectedEditID == '' ? true : false} className='eMed_room_radio'>
                                <RadioGroup
                                    value={this.state.SelectedStatus}
                                    sx={{ display: 'flex', flexDirection: 'row' }}
                                    onChange={(e) => { this.setState({ SelectedStatus: e.target.value }) }}
                                >
                                    <FormControlLabel value={true} control={<Radio size='small' />} label="Active" />
                                    <FormControlLabel value={false} control={<Radio size='small' />} label="InActive" />
                                </RadioGroup>
                            </FormControl>
                        </div>
                        <div style={{ marginTop: "-0.5vw" }}>
                            <p className='eMed_Testconfig_RightHead_text'>{t('Upload Your Signature')}</p>
                        </div>
                        <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", marginTop: "-0.5vw" }}>
                            {this.renderImgCard()}
                        </div>
                        <div className='eMed_TestConfig_RightBtnCon'>
                            <Stack spacing={2} direction="row">
                                <Button id='eMed_Btn_Text' variant='outlined' onClick={() => { this.clearValue() }}>{t("Clear")}</Button>
                                <Button id='eMed_Btn_Text' emed_tid='SignConfig_Save_Btn' disabled={this.state.disableBtn ? true : !CheckAccessFunc("Radiology", "Settings", "E-Signature Configuration", null, "Tab")?.editAccess} variant='contained' onClick={() => { this.validation() }}>{t("Save")}</Button>
                            </Stack>
                        </div>
                    </div>
                </div>
                {this.state?.AddnewRoleType ? this.renderRoleAdd() : null}
                {this.state.CropPop ?
                    <div>
                        {this.OpenCropPopUP()}
                    </div>
                    : null
                }
                {this.state.isErrorMsg ?
                    <ToastMsg
                        severity={'error'}
                        msg={this.state.isErrorMsgText}
                        msgPop={this.msgClose.bind(this)}
                    />
                    : null}
                {this.state.successMsg ?
                    <ToastMsg
                        severity={'success'}
                        msg={this.state.successMsgText}
                        msgPop={this.msgClose.bind(this)}
                    />
                    : null}
                {this.state.deletedPopup ?
                    <DeletePopup DeletTitle={t("Are You Sure? Do you want to remove this Signature")}
                        DeleteNotify={t("effectEntireConfig")}
                        DeletContent={t("This Signature is linked with various Configuration")}
                        deleteAlertPopupClose={this.PopupClose.bind(this)}
                        removeData={this.removeDataList.bind(this)}
                        disable={this.state.removeData}
                    />
                    : null}
                {this.state.popUpOpen ?
                    this.previewPopup()
                    : null
                }
                {this.state?.deleteRole ? <ConfirmPopup
                    cnfTitle={t('Confirmation')}
                    cnfContent={t('Are you sure, Do you want Delete the Role, It will be effect the entire Reports')}
                    cnfAlertPopupClose={this.popClose.bind(this)}
                    cnfData={this.deleteRole.bind(this)}
                /> : null}

            </div>
        )
    }
}
export default withTranslation()(RadESign)